import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { Link, useLocation, useSearchParams } from "react-router-dom"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"

const listMenu = [
  {
    name: "Wilayah",
    path: "/admin/master/wilayah",
  },
  {
    name: "Wilayah Merge",
    path: "/admin/master/wilayah-merge",
  },
]

const getWilayahMerge = async (searchQuery: string) => {
  const response = await api.get(
    `/master/wilayah/kecamatan${searchQuery ? `?search=${searchQuery}` : ""}`
  )
  return response.data?.data
}

export default function MasterWilayahMergePage() {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const searchQueryParams = searchParams.get("search") || ""

  const { data, isPending } = useQuery({
    queryKey: ["listWilayahMerge", searchQueryParams],
    queryFn: () => getWilayahMerge(searchQueryParams),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <div className="rounded-full border overflow-hidden flex w-fit">
        {listMenu.map((menu, index) => {
          const active = menu.path === pathname
          return (
            <Link
              key={index}
              to={menu.path}
              className={`py-2 px-3  ${
                active
                  ? `bg-black text-white ${
                      index === 0
                        ? "rounded-r-full"
                        : index === listMenu.length
                        ? "rounded-l-full"
                        : "rounded-full"
                    }`
                  : "hover:bg-secondary cursor-pointer"
              }`}
            >
              <span className="font-semibold text-sm">{menu.name}</span>
            </Link>
          )
        })}
      </div>

      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
